import type { Report } from "../types";
import { ReportRenderer } from "./ReportRenderer";

export function ReportBody({ report }: { report: Report }) {
  return <ReportRenderer report={report} />;
}
